import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import "@/App.css";
import AdminPanel from "@/components/AdminPanel";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function App() {
  const [serverVersion, setServerVersion] = useState("");

  useEffect(() => {
    fetch(`${BACKEND}/api/health`)
      .then((r) => r.json())
      .then((d) => setServerVersion(d.version || ""))
      .catch(() => {});
  }, []);

  return (
    <div className="app-root">
      <div className="wrap">
        <header className="app-header">
          <div className="brand" data-testid="brand">
            <img src="/logo.png" alt="AqmOpti" />
            AqmOpti<span>Optimisation BIOS</span>
          </div>
          {serverVersion && (
            <div className="server-version" data-testid="server-version" title="Version du serveur déployé">
              serveur v{serverVersion}
            </div>
          )}
        </header>

        <AdminPanel />
      </div>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: { background: "#1E2229", border: "1px solid #333A45", color: "#DDE1E8" },
        }}
      />
    </div>
  );
}
